import { Component, OnInit, Input } from '@angular/core';
import { FormVariable } from 'app/common/model/form-variable';

@Component({
  selector: 'mc-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss']
})
export class RadioButtonComponent implements OnInit {

  @Input() formVariable: FormVariable

  constructor() { }

  ngOnInit() {
  }

}
